import { Component, Input } from '@angular/core';

import { arrowRightButtonIcon } from '../../../icons';
import { FieldBaseComponent } from '../field-base/field-base.model';
import { SidePanelService } from '../../side-panel/side-panel.service';
import { IndicataService } from '../../indicata/indicata.service';

@Component({
    selector: 'app-input-licenseplate',
    template: `
        <form (ngSubmit)="onSubmit()">
            <div class="license-plate-input">
                <div class="license-plate-input__content">
                    <div class="license-plate-plaque" aria-hidden="true">
                        <div class="license-plate-plaque__stars"></div>
                        <div class="license-plate-plaque__country-code text-small">DK</div>
                    </div>
                    <label class="license-plate-input__wrapper">
                        <input
                            type="text"
                            class="input__input-element"
                            [ngClass]="cssClasses"
                            [class.input__input-element--not-empty]="licensePlate"
                            [(ngModel)]="licensePlate"
                            [ngModelOptions]="{standalone: true}"
                        />
                        <span class="input__label">{{ label }}</span>
                    </label>
                </div>

                <button type="submit" class="button--primary license-plate-plaque__button">
                    Beregn pris
                    ${arrowRightButtonIcon}
                </button>
            </div>
        </form>
    `,
})
export class InputLicensePlateComponent extends FieldBaseComponent {
    @Input() cssClasses: string;
    @Input() label: string;

    licensePlate: string;

    constructor(
        private indicataService: IndicataService,
        private sidePanelService: SidePanelService
    ) {
        super();
    }

    onSubmit() {
        this.indicataService.bootstrapSequenceWithRegistrationNumber(this.licensePlate);
        this.sidePanelService.showExhangeCarSidePanel(true);
    }
}
